// extracted by mini-css-extract-plugin
export default {"Img":"MobileLogo_Img__2msma","Container":"MobileLogo_Container__-JP3K"};